module.exports = __webpack_public_path__ + "img/sad.7d5aa4a6.svg";